export const modalConstants = {
  DEFAULT: "DEFAULT",
  NUMBER_INPUT_FIELD: "NUMBER_INPUT_FIELD",
  TEXT_AREA_INPUT_FIELD: "TEXT_AREA_INPUT_FIELD",
};

export const modalMessageconstants = {
  DISMISS_NOTIFICATION_CONFIRM_MODAL:
    "Do you want to dismiss the notification(s)?",
};
